// Global Components
import * as React from 'react';
import ReactSlider from 'react-slider';

// Helpers
import _ from 'lodash';
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $OptionalProps = {
  active?: boolean;
  iconClassName?: string;
  max?: number;
  onChange?: (value: number) => unknown;
  onClick?: (value: number) => unknown;
  thumbClassName?: string;
  value?: number;
};

type $Props = $OptionalProps & {
  name: string;
};

type $State = {
  value: number;
};

const defaultMax: number = 100;

class InputSliderView extends React.Component<$Props, $State> {
  onChange: (value: number) => unknown;

  static defaultProps: $OptionalProps = {
    active: undefined,
    iconClassName: undefined,
    max: undefined,
    onChange: undefined,
    onClick: undefined,
    thumbClassName: undefined,
    value: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      value: props.value || 0,
    };

    this.onChange = _.debounce(
      (value: number) => {
        if (props.onChange) {
          props.onChange(value);
        }
      },
      500,
    );
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      value,
    } = this.props;

    if (typeof value !== 'undefined' && isDiff(
      value,
      prevProps.value,
    )) {
      this.setValue({
        value,
      });
    }
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async setValue({
    value,
  }: {
    value: number;
  }): Promise<void> {
    await this.setStateAsync({
      value,
    });

    this.onChange(value);
  }

  render() {
    const {
      iconClassName,
      max,
      name,
      onClick,
      thumbClassName,
    } = this.props;
    const {
      value,
    } = this.state;

    const definedMax: number = max || defaultMax;

    return (
      <ReactSlider
        className={'rounded-full border h-10 w-100'}
        max={definedMax}
        name={name}
        onChange={(newValue) => this.setValue({
          value: newValue,
        })}
        onSliderClick={onClick}
        renderThumb={(props) => (
          <button
            // eslint-disable-next-line
            {...props}
            className={`btn ${thumbClassName || ''} uppercase px-2 py-1 h-10 -mt-px`}
            type={'button'}
          >
            <em className={`la ${iconClassName || 'la-play'} text-2xl`} />
          </button>
        )}
        trackClassName={''}
        value={value}
      />
    );
  }
}

export default InputSliderView;
